<template>
  <b-modal
    centered
    id="temp-modal"
    title="Детали шаблона"
    ok-title="Сохранить"
    cancel-title="Отменить"
    @ok.prevent="saveData"
    @show="openModal"
    @hidden="clearModal"
  >
    <div>
      <b-form-group label="Название шаблона">
        <b-form-input placeholder="Название шаблона" v-model="template.title" />
      </b-form-group>
      <b-form-group label="Файл шаблона">
        <b-form-file
          v-model="template.file"
          placeholder="Выберите файл или перетащите его сюда"
          drop-placeholder="Перетащите сюда"
        />
      </b-form-group>
    </div>
  </b-modal>
</template>

<script>
import { BModal, BFormFile, BFormGroup, BFormInput } from 'bootstrap-vue'
import { mapActions } from 'vuex'
export default {
  components: {
    BModal,
    BFormFile,
    BFormGroup,
    BFormInput,
  },

  props: {
    templateProps: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },

  data() {
    return {
      template: {
        title: '',
        id: null,
        file: null,
      },
    }
  },

  methods: {
    ...mapActions('contracts', [
      'ADD_CONTRACT_TEMPLATE',
      'EDIT_CONTRACT_TEMPLATE',
    ]),

    async saveData() {
      const { file, ...rest } = this.template
      const formData = this.$_objectToFormData({
        file: typeof file == 'string' ? null : file,
        ...rest,
      })
      if (this.templateProps.id) {
        await this.EDIT_CONTRACT_TEMPLATE(formData)
      } else {
        await this.ADD_CONTRACT_TEMPLATE(formData)
      }
      this.$bvModal.hide('temp-modal')
      this.$emit('saved')
    },

    openModal() {
      if (this.templateProps.id) {
        this.template = { ...this.templateProps }
      } else {
        this.clearModal()
      }
    },

    clearModal() {
      this.template = {
        title: '',
        id: null,
        file: null,
      }
    },
  },
}
</script>
